/**
 * Le **`clientToken`** : la moitié cliente de la clé d'idempotence des écritures
 * du webmail (`api-types/webmail.ts`, propriété n°2).
 *
 * La règle tient en deux phrases, et tout le reste du webmail en dépend :
 *
 *  - **un jeton par INTENTION** — ouvrir le composeur, cliquer « Archiver ».
 *    Une nouvelle intention regénère ;
 *  - **le même jeton pour tous les REJEUX de cette intention** — double-clic,
 *    retry réseau, onglet rechargé. Le serveur rend alors la même `opId` et
 *    `duplicate: true`, au lieu d'envoyer deux fois le même mail.
 *
 * Corollaire : ce module ne fabrique jamais un jeton « au moment de la
 * requête ». Il est appelé par les stores au moment du GESTE, et la valeur est
 * conservée dans l'état tant que le geste n'a pas abouti.
 */

/** Les bornes du contrat : 8 à 128 caractères, alphabet url-safe. */
const ALPHABET = 'abcdefghijklmnopqrstuvwxyz0123456789';

/**
 * Un identifiant unique, url-safe.
 *
 * `crypto.randomUUID` est la source normale — un UUID v4 passe le
 * `clientTokenSchema` tel quel (36 caractères, `[0-9a-f-]`). Le repli existe
 * pour les contextes où l'API n'est pas là : `randomUUID` exige un contexte
 * sécurisé, et le front tourne aussi derrière un `http://` en développement.
 * Le repli n'a pas besoin d'être cryptographique : ce jeton n'est pas un secret,
 * il ne sert qu'à ne pas se confondre avec le geste d'à côté.
 */
export function newClientToken(): string {
  const uuid = globalThis.crypto?.randomUUID?.();
  if (uuid !== undefined) return uuid;

  let token = 'loopandroll-';
  for (let index = 0; index < 24; index += 1) {
    token += ALPHABET[Math.floor(Math.random() * ALPHABET.length)];
  }
  return `${token}-${Date.now().toString(36)}`;
}
